import * as React from 'react';

type ImageWithFallbackProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallbackSrc: string;
};

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, fallbackSrc, alt, ...props }) => {
  const [currentSrc, setSrc] = React.useState('');
  const imgRef = React.useRef<HTMLImageElement>(null);

  React.useEffect(() => {
    const ref = imgRef.current;

    const handleDownloadError = (): void => {
      if (currentSrc !== fallbackSrc) {
        setSrc(fallbackSrc);
      }
    };

    if (ref) {
      ref.addEventListener('error', handleDownloadError);
    }

    return (): void => {
      ref?.removeEventListener('error', handleDownloadError);
    };
  }, [imgRef, fallbackSrc]);

  React.useEffect((): void => {
    if (!src) {
      setSrc(fallbackSrc);
    } else {
      setSrc(src);
    }
  }, [src, fallbackSrc]);

  return <img src={currentSrc} ref={imgRef} alt={alt} {...props} />;
};

export default ImageWithFallback;
